import React from 'react';
import classnames from 'classnames';

import styles from './main-content-container.module.css';

type MainContentContainerProps = {
    children: React.ReactNode;
    className?: string;
};

const MainContentContainer = ({ children, className }: MainContentContainerProps) => {
    return <main className={classnames(styles.container, className)}>{children}</main>;
};

export { MainContentContainer };
